
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media-kits",
      function () {
        return require("private-next-pages/media-kits/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media-kits"])
      });
    }
  